var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShape = function SvgShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.762,
    height: 24.876
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#4e4e4e",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 223",
    d: "M.25.25h28.262v8.432H7.724v15.941H.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 224",
    d: "M12.611 11.902h7.825v7.538h-8.2v-8.2"
  }))));
};
export default SvgShape;